import React from 'react'
import CustomTable from '../../../../elements/Table/CustomTable'
import { Button } from 'antd'
import MoneyCell from '../../../../elements/Table/Cells/MoneyCell'
import SumFooter from '../../../../elements/Table/Footers/SumFooter'

function List(props) {
  const { list, isUpdatable, fetch, fetching, onShow } = props

  const columns = [
    {
      Header: 'No',
      accessor: 'no',
      width: 50,
      Cell: ({ value, original }) => <a onClick={() => onShow(original, 'edit')}>{value}</a>,
    },
    {
      Header: 'Name',
      accessor: 'name',
      width: 250,
    },
    { Header: 'Part No', accessor: 'materials.oem.vendorNo' },
    { Header: 'Product', accessor: 'product.fn' },
    { Header: 'Unit', accessor: 'unit' },
    { Header: 'UOM', accessor: 'uom.code', hideable: true, hideDefault: false },
    { Header: 'Rate', accessor: 'rate', Cell: MoneyCell },
    { Header: 'Tax', accessor: 'tax.rate', hideable: true, hideDefault: true },
    { Header: 'Tax Type', accessor: 'tax.type', hideable: true, hideDefault: true },
    { Header: 'Sub-Total', accessor: 'amount.net', hideable: true, hideDefault: false, Cell: MoneyCell, Footer: SumFooter },
    { Header: 'Tax-Total', accessor: 'amount.tax', hideable: true, hideDefault: false, Cell: MoneyCell, Footer: SumFooter },
    { Header: 'Total', accessor: 'amount.gross', hideable: true, hideDefault: false, Cell: MoneyCell, Footer: SumFooter },
  ]

  return (
    <CustomTable
      data={list}
      defaultPageSize={20}
      isFilterable={true}
      fetching={fetching}
      fetch={fetch}
      CreateButton={() => (
        <Button
          disabled={!isUpdatable}
          type={'primary'}
          size="small"
          icon={'plus'}
          onClick={onShow}>
          Add Line
        </Button>
      )}
      columns={columns}
    />
  )
}

List.propTypes = {}
List.defaultProps = {}

export default List
